import { InfoCell } from '@/components/shared/InfoCell';
import { strings } from '@/services/translation/strings';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface MonthlyTotalHeaderProps {
  showDayTotals?: boolean;
}

export const DailyTotalHeader: FC<MonthlyTotalHeaderProps> = () => {
  return (
    <InfoCell className={twMerge('flex-1 border-r')}>
      <p>{strings.common.totals.dailyTotal}</p>
    </InfoCell>
  );
};
